export * from '@thalesrc/js-utils/map/merge';
